const store = require("./store.js");
const Config = require("~/config.js"); 

const navigator = {
    InCurrentPage: {
        GoToSection(sectionID) {
            const currentSurvey = currentSurvey || getCurrentSurveyOrThrow();

            if (sectionID === Config.ConfirmationPage)
            {
                const newHash = navigator.GetLink.ToConfirmation(currentSurvey);

                window.location.hash = newHash;
                
                return; 
            }

            const newHash = navigator.GetLink.ToSection(currentSurvey, sectionID);
            
            window.location.hash = newHash;
        }
    },
    OpenSurvey(auditTypeName, facilityNumber, surveyID) {
        const newHash = navigator.GetLink.ToSurvey(auditTypeName, facilityNumber, surveyID);

        window.location.hash = newHash;
    },
    OpenSurveySummary(auditTypeName, facilityNumber, surveyID) {
        const newHash = navigator.GetLink.ToSummary(auditTypeName, facilityNumber, surveyID);

        window.location.hash = newHash;
    },
    GetLink: {
        ToConfirmation(currentSurvey) {
            return `survey-confirmation/${currentSurvey.Type}/${currentSurvey.FacilityNumber}/${currentSurvey.GUID}`;
        },
        ToSurvey(auditTypeName, facilityNumber, surveyID) {
            return `survey/${auditTypeName}/${facilityNumber}/${surveyID}`;
        },
        ToSummary(auditTypeName, facilityNumber, surveyID) {
            return `survey-summary/${auditTypeName}/${facilityNumber}/${surveyID}`;
        },
        ToLegacySurvey(auditTypeName, facilityNumber, surveyID) {
            return `legacy-survey/${auditTypeName}/${facilityNumber}/${surveyID}`;
        },
        ToSection(currentSurvey, sectionID) {
            return `survey/${currentSurvey.Type}/${currentSurvey.FacilityNumber}/${currentSurvey.GUID}/${currentSurvey.CurrentPageGUID}/${sectionID}`;
        },
        ToAttachment(attachment) {
            return `${Config.RootApiUrl}file?AuditID=${attachment.AuditID}&Name=${attachment.Name}&Key=${attachment.Key}`;
        },
        ToReports() {
            return "reports";
        }
    }
};

function getCurrentSurveyOrThrow() {
    const currentSurvey = store.getState()["CurrentSurvey"];

    if (!currentSurvey) {
        throw "No survey is currently selected.";
    }

    return currentSurvey;
}

function getAdjacentSectionGUID(survey, interval) {
    const page =
        survey.Pages.find((p) => p.GUID === survey.CurrentPageGUID)
        || survey.Pages[0];

    const currentSection =
        page.Sections.find((s) =>
            s.GUID === survey.CurrentSectionGUID);

    if (!currentSection) {
        throw `Section ${survey.CurrentSectionGUID} does not exist`;
    }

    const newSection =
        page.Sections.find((s) =>
            s.DisplayOrder === (currentSection.DisplayOrder + interval));

    if (!newSection) {
        throw `A section following ${survey.CurrentSectionGUID} does not exist`;
    }

    return newSection.GUID;
};

module.exports = navigator;


// WEBPACK FOOTER //
// ./src/navigator.js